import normalize from 'json-api-normalize';
import { MediaPathHelper } from '../helpers/media-path.helper';
import { VideoModel } from './video.model';

export class PromotionModel {

  public static parsePromo(json, baseImageUrl: string): PromotionModel[] {
    const data = normalize(json).get([
      'items'
    ]);

    if (Array.isArray(data) && data[0].items && data[0].items.dataset && data[0].items.dataset.data) {
      return data[0].items.dataset.data.map(promo => {
        let imageUrl;
        let videoModel;

        if (promo && promo.relationships && promo.relationships.field_media.data) {
          if (promo.relationships.field_media.data.type === 'media--image') {
            const media = data[0].items;
            const promoImage = MediaPathHelper.getMedia(promo.relationships.field_media, media.dataset.included);

            if (promoImage) {
              imageUrl = promoImage['square']['href'];
            }
          } else if (promo.relationships.field_media.data.type === 'media--remote_video') {
            const mediaId = promo.relationships.field_media.data.id;
            const media = data[0].items.dataset.included.find(f => f.id === mediaId);
            if (media) {
              videoModel = VideoModel.parseVideo({ data: media });
            }
          }
        }

        return new PromotionModel({
          title: promo.attributes.info,
          promotion: promo.attributes.field_description,
          ctaText: promo.attributes.field_cta ? promo.attributes.field_cta.title : '',
          ctaURL: promo.attributes.field_cta ? promo.attributes.field_cta.uri.replace('internal:', '') : '',
          image: imageUrl,
          video: videoModel,
          showBanner: promo.attributes.field_is_active
        });
      });
    } else {
      return null;
    }
  }

  public title: string;
  public promotion: string;
  public ctaText: string;
  public ctaURL: string;
  public image: string;
  public showBanner: boolean;
  public video: VideoModel;

  constructor(values?: Partial<PromotionModel>) {
    Object.assign(this, values);
  }
}
